export default __webpack_public_path__ + "static/media/cruel.6f8f9db3.jpg";